inputs-without-label-textfield
  input(class="form-control { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" type="text" value="{ opts.value }" onInput="{this.onInput}" onChange="{this.onChange}")
  div.help-block(if="{ opts.errors }")
    ul(role="alert")
      li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.textfield');
